<template>
    <BreadCrumb PageTitle="Liste des classes" />
    <ListeClasse />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeClasse from "../../components/Classe/ListeClasse.vue";

  
    export default defineComponent({
      name: "ListeClassePage",
      components: {
        BreadCrumb,
        ListeClasse,
      },
    });
  </script>